import {
  getAllInsuredsFromParties,
  getProductLineByPolicyType,
} from "js/utilities";
import { getName } from "./getName";

export const getPoliciesOptions = (policies) => {
  if (!Array.isArray(policies)) return [];

  const policySelectionArray = policies.map((policy) =>
    createPolicyOption(policy, policies)
  );

  return policySelectionArray.sort((a, b) =>
    a.value.localeCompare(b.value, "en", { numeric: true })
  );
};

const createPolicyOption = (policy, policies) => {
  const policyDetails = findPolicyByOldPolicy(policies, policy.oldPolicy);

  return {
    displayAs: formatDisplayString(policyDetails),
    value: policy.oldPolicy,
    prodType: getProductLineByPolicyType(policy?.product?.type),
    contractID: policy.contractID,
    insuredName: extractInsuredFullName(policyDetails),
    status: policy?.status,
    policyData: {
      status: policy?.status,
      premiumDueDate: policy?.premiumDueDate,
      costOfInsurance: policy?.costOfInsurance,
      modalPremiumAmountTotal: policy?.modalPremiumAmountTotal,
      product: policy?.product,
    },
  };
};

const findPolicyByOldPolicy = (policies, oldPolicyId) => {
  return policies.find((p) => p.oldPolicy === oldPolicyId);
};

const formatDisplayString = (policyDetails) => {
  return `${policyDetails.oldPolicy} - ${extractInsuredFullName(
    policyDetails
  )}`;
};

const extractInsuredFullName = (policyDetails) => {
  const insuredParties = getAllInsuredsFromParties(policyDetails?.parties);
  const insuredParty = insuredParties.find((i) => i.person?.personId === "01");
  return getName(insuredParty?.person, "titlecase");
};
